import r from "./index860.js";
function o(t) {
  return t == null ? "" : r(t);
}
export {
  o as default
};
